import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a54d90f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign-title" }, "中通快递费用对账单", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sign-txt__1" }, "合同类型：", -1))
const _hoisted_3 = { class: "sign-txt__2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sign-txt__1" }, "合同主体：", -1))
const _hoisted_5 = { class: "sign-txt__2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sign-txt__1" }, "对账人姓名：", -1))
const _hoisted_7 = { class: "sign-txt__2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sign-txt__1" }, "对账人手机号：", -1))
const _hoisted_9 = { class: "sign-txt__2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sign-txt__1" }, "对账结算客户：", -1))
const _hoisted_11 = { class: "sign-txt__2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sign-t" }, "费用汇总", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "sign-txt__3" }, " 双方一致同意通过快递管家线上电子对账方式完成费用账单核对； "),
  /*#__PURE__*/_createElementVNode("div", { class: "sign-s flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "确认人："),
    /*#__PURE__*/_createElementVNode("div", { class: "sign-line" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "sign-s flex" }, [
    /*#__PURE__*/_createElementVNode("div", null, "确认时间："),
    /*#__PURE__*/_createElementVNode("div", { class: "sign-line" })
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 发起签署 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_ReportTable = _resolveComponent("ReportTable")!
  const _component_AdminTableLayout = _resolveComponent("AdminTableLayout")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    ref: "formDialogRefs",
    title: "电子签账单确认",
    width: "1200px",
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleRef) = $event))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "system-btn",
        type: "primary",
        size: "mini",
        loading: _ctx.loading,
        onClick: _ctx.handleSure
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_AdminTableLayout, {
        needSearchForm: false,
        isDialog: true,
        style: {"height":"464px","font-family":"宋体-简"}
      }, {
        "content-header": _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_el_row, { class: "mt-8" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formData.accountBillTypeDesc), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formData.contractSubject), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "mt-8" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formData.accountName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formData.accountPhone), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.formData.contractProjectName)
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0,
                class: "mt-8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formData.customerName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_12
        ]),
        "content-table": _withCtx(() => [
          _createVNode(_component_ReportTable, {
            tableHeight: "",
            loading: _ctx.loading,
            tableData: [_ctx.formData],
            showTableColumn: _ctx.showTableColumnAll
          }, null, 8, ["loading", "tableData", "showTableColumn"])
        ]),
        "foot-action": _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}